import { render, staticRenderFns } from "./Theme4Section3.vue?vue&type=template&id=07ec5114&scoped=true&"
import script from "./Theme4Section3.vue?vue&type=script&lang=js&"
export * from "./Theme4Section3.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Section3.vue?vue&type=style&index=0&id=07ec5114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec5114",
  null
  
)

export default component.exports